export const SEND_OTP_START = 'SEND_OTP_START';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_ERROR = 'SEND_OTP_ERROR';
export const SEND_OTP_END = 'SEND_OTP_END';
export const SEND_OTP_CLEAR = 'SEND_OTP_CLEAR';
